/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @import Store/Global                                                                         **/
/**************************************************************************************************/
import Store from '@/Store/Global/Default'

/**************************************************************************************************/
/** @internal Const @name MixinComponent                                                         **/
/**************************************************************************************************/
const MixinComponent = defineComponent(
{
	/*************************************************/
	/** @Data                                       **/
	/*************************************************/
	data()
	{
		return {
			states: {}
		}
	},

	/*************************************************/
	/** @Hooks                                      **/
	/*************************************************/
	beforeMount()
	{
		Store.commit('updateViewsModuleEnvironment', this.GetComponentParamModuleEnvironment)
	},

	/*************************************************/
	/** @Computed                                   **/
	/*************************************************/
	computed:
	{
		GetComponentParamModuleEnvironment() : 'External' | 'Internal' | 'Storage'
		{
			const fromParams = this.$route.params['moduleEnvironment'] as 'External' | 'Internal' | 'Storage'
			return fromParams || Store.getters.getStoredViews.moduleEnvironment as 'External' | 'Internal' | 'Storage'
		}
	},

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	methods:
	{
		Set<S = {}>(states: MixinComponentStatesType<S>) : void
		{
			for (let name in states) (this.states as any)[name] = states[name]
		}
	}
})

/**************************************************************************************************/
/** @export Component @name MixinComponent                                                       **/
/**************************************************************************************************/
export default MixinComponent

/**************************************************************************************************/
/** @export Type @name MixinComponentRef                                                         **/
/**************************************************************************************************/
export type MixinComponentRef = InstanceType<typeof MixinComponent>

/**************************************************************************************************/
/** @export Type @name MixinComponentStatesType<S>                                               **/
/**************************************************************************************************/
export type MixinComponentStatesType<S> = { [K in keyof S]?: S[K] }